import { ForgotPasswordActionManager } from "../../../action_managers/forgot_password";
import ForgotPasswordPage from "./forgot_password_page";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withPageTitle } from "../../lib/WithPageTitle";

function mapStateToProps(state) {
  return {
    isLoading: state.forgotPassword.isLoading,
    hasMessage: state.forgotPassword.hasMessage,
    isError: state.forgotPassword.isError,
    message: state.forgotPassword.message,
    isSuccess: state.forgotPassword.isSuccess,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    forgotPassword: formJSON => {
      dispatch(new ForgotPasswordActionManager({ email: formJSON.email }).run());
    },
  };
}

const ForgotPasswordPageWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage)
);

export default withPageTitle(ForgotPasswordPageWrapper, "Forgot Password");
